export default __webpack_public_path__ + "static/media/cloud.c3762f8b.png";